export class AnnouncementModel {
    id : string;
    announcementId: string;
    title: string;
    message: string;
    attachment: string;
    attachmentFile: any;
    companyId: string;
    companyName: string;
    status: boolean;
   
    constructor() {
        this.id ="";
        this.announcementId="";
        this.title="";
        this.message="";
        this.attachment="";
        this.attachmentFile =null;
        this.companyId = "";
        this.companyName="";
        this.status = false;
   
    }
}
